/**
 * @generated SignedSource<<c7205a751a04742f58ebfcaecab84714>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeEditExtra_whatToSee$data = {
  readonly blocks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly description: string | null;
        readonly id: string;
        readonly name: string;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksField_blocksConnection">;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeBlocksField_whatToSee">;
  readonly " $fragmentType": "WhatToSeeEditExtra_whatToSee";
};
export type WhatToSeeEditExtra_whatToSee$key = {
  readonly " $data"?: WhatToSeeEditExtra_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditExtra_whatToSee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeEditExtra_whatToSee",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "WhatToSeeBlockConnection",
      "kind": "LinkedField",
      "name": "blocks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WhatToSeeBlockEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WhatToSeeBlock",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WhatToSeeBlocksField_blocksConnection"
        }
      ],
      "storageKey": "blocks(first:2147483647)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WhatToSeeBlocksField_whatToSee"
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};
})();

(node as any).hash = "6edaa7b45fc004a6de65c2ed96c7d1c8";

export default node;
